import React, { useState } from "react";
import { SlLock } from "react-icons/sl";
import { TfiEye } from "react-icons/tfi";
import { IoEyeOffOutline } from "react-icons/io5";

export const CambiarContrasena = () => {

    // Estados para cada campo
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // Estados para mostrar/ocultar cada campo
    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    // Handlers para cambiar el texto de los inputs
    const handleCurrentPassword = (e) => setCurrentPassword(e.target.value);
    const handleNewPassword = (e) => setNewPassword(e.target.value);
    const handleConfirmPassword = (e) => setConfirmPassword(e.target.value);

    return (
        <>
            <div class="container-password">
                <h2 class="title-password" style={{ display: 'flex', gap: '8px' }}>
                    <SlLock />
                    Cambiar Contraseña
                </h2>
                <p class="subtitle-password">
                    Si usted quiere cambiar su Contraseña, por favor ingrese una nueva ahora.
                </p>

                <form>
                    <div class="form-group-password">
                        <label for="current-password">Contraseña Actual*</label>
                        <div class="input-wrapper-password">
                            <input
                                type={showCurrent ? 'text' : 'password'}
                                // id="current-password"
                                placeholder="*************"
                                onChange={handleCurrentPassword}
                                value={currentPassword}
                            />
                            <span
                                onClick={() => setShowCurrent(!showCurrent)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}

                            >
                                {showCurrent ? <IoEyeOffOutline size={20} style={{ color: '#C1C1C1' }} /> : <TfiEye size={20} style={{ color: '#C1C1C1' }} />}
                            </span>
                        </div>
                    </div>

                    <div class="form-group-password">
                        <label for="new-password">Contraseña*</label>
                        <div class="input-wrapper-password">
                            <input
                                type={showNew ? 'text' : 'password'}
                                // id="new-password"
                                value={newPassword}
                                onChange={handleNewPassword}
                                placeholder="*************"
                            />
                            <span
                                onClick={() => setShowNew(!showNew)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}
                            >
                                {/* <TfiEye style={{ color: "C1C1C1" }} className="eye-icon" /> */}
                                {showNew ? <IoEyeOffOutline size={20} style={{ color: '#C1C1C1' }} /> : <TfiEye size={20} style={{ color: '#C1C1C1' }} />}                        </span>
                        </div>
                    </div>

                    <div class="form-group-password">
                        <label for="confirm-password">Confirmar Contraseña*</label>
                        <div class="input-wrapper-password">
                            <input
                                type={showConfirm ? 'text' : 'password'}
                                // id="confirm-password"
                                value={confirmPassword}
                                onChange={handleConfirmPassword}
                                placeholder="*************" />
                            <span
                                onClick={() => setShowConfirm(!showConfirm)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}
                            >
                                {showConfirm ? <IoEyeOffOutline size={20} style={{ color: '#C1C1C1' }} /> : <TfiEye size={20} style={{ color: '#C1C1C1' }} />}
                            </span>
                        </div>
                    </div>

                    <div type="submit" class="btn-submit">Cambiar Contraseña</div>
                </form>

            </div>
            <div className="dashed-line"></div>
        </>
    )
}
